jQuery(document).ready(function($) {
  $('.m-form__signup--footer .wpcf7-submit').click( function() {
    $('.m-form__signup--footer .wpcf7-response-output').removeClass('forcehide');
    //alert('clicked');
  });
  $('.m-form__signup--footer .wpcf7-response-output').click( function() {
    $('.m-form__signup--footer .wpcf7-response-output').addClass('forcehide');
    //alert('clicked');
  });
});
